export class CreacionSession {
	user: string;
	elementId: string;
	cabinCode: string;
	tactical: boolean;
	commited: boolean;
}
